import { RouteComponentProps } from "react-router";
import { Route, Switch } from "react-router-dom";
import { OrganizationClientGrantsProps } from "../../services/types";
import SettingsClientGrantsIndexPage from "./pages/Index";

const SettingsClientGrantsPage = (props: RouteComponentProps & OrganizationClientGrantsProps) => {
	return (
		<div className="content">
			<Switch>
				<Route path={props.match.url} exact render={() => <SettingsClientGrantsIndexPage {...props} />} />
			</Switch>
		</div>
	);
};

export default SettingsClientGrantsPage;
